import CardWrapper from '../../components/wrapper/card';
import DomainComponent from '../../components/domain';
import { settingSelectedTabForCompany } from '../../redux/slices/team';
import SubscriptionComponent from '../../components/subscription';
import TeamComponent from '../../components/team';
import { a11yProps, CustomTabPanel } from '../deals';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Divider, Tab, Tabs } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

const CompanyManagementPage = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { selectedTab } = useSelector((state: RootState) => state.team);

    const handleChange = (event: React.SyntheticEvent, newValue: 0 | 1 | 2) => {
        dispatch(settingSelectedTabForCompany(newValue));
    };

    return (
        <Box p={2}>
            <CardWrapper minHeight="85vh" overflow="auto">
                <Tabs
                    value={selectedTab}
                    onChange={handleChange}
                    aria-label="Company management details tabs"
                >
                    <Tab
                        label="Team"
                        {...a11yProps(0)}
                    />
                    <Tab
                        label="Domain"
                        {...a11yProps(1)}
                    />
                    <Tab
                        label="Subscription"
                        {...a11yProps(2)}
                    />
                </Tabs>
                <Divider />
                <CustomTabPanel value={selectedTab} index={0}>
                    {selectedTab === 0 && <TeamComponent />}
                </CustomTabPanel>

                <CustomTabPanel value={selectedTab} index={1}>
                    {selectedTab === 1 && <DomainComponent />}
                </CustomTabPanel>

                <CustomTabPanel value={selectedTab} index={2}>
                    {selectedTab === 2 && <SubscriptionComponent />}
                </CustomTabPanel>
            </CardWrapper>
        </Box>
    );
};

export default CompanyManagementPage;